/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { CitationModule } from '@coursera-web/cds-labs';

const styles = {
  wrapper: css`
    p {
      margin-bottom: 0;
    }
  `,
};

const CourseraPlusCitations = () => {
  return (
    <div css={styles.wrapper}>
      <CitationModule
        citations="1 - [Learner Outcome Report 2023](https://about.coursera.org/press/wp-content/uploads/2023/05/Learner-Outcomes-Report-2023.pdf)"
        removeTopPadding
      />
    </div>
  );
};

export default CourseraPlusCitations;
